import urls from "@/constants/urls";
import axios from "axios";

/**
 * @typedef {Object} GenerateReportURLPayload
 * @property {string}   report_id - The ID of the report to generate.
 * @property {string}   user_email - The email of the user requesting the report.
 * @property {Number[]} export_campaign_list - List of campaign IDs to include in the report
 */

export const useGoogleLookerStudioAPI = () => {
  /**
   * Fetches comparison data for a campaign against the same period last year.
   * @param {string} oid - Organization ID.
   * @returns {Promise<any>} A promise that resolves to an array containing the
   * comparison data and any error that occurred during the request.
   */
  const fetchConfiguration = async (oid) => {
    const url = urls.googleLookerStudio(oid);

    return await axios
      .get(url)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error.response ? error.response.data : error));
  };

  /**
   * Generates a report URL for Google Looker Studio.
   * @param {string} oid - Organization ID.
   * @param {GenerateReportURLPayload} payload - The payload containing report parameters.
   * @returns {Promise<any>} A promise that resolves to the generated report URL.
   */
  const fetchGenerateReportURL = (oid, payload) => {
    const url = urls.googleLookerStudio(oid);

    return axios
      .post(url, payload)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error.response ? error.response.data : error));
  };

  return {
    fetchConfiguration,
    fetchGenerateReportURL,
  };
};
